import { AppRoute } from '@app/core/routing/AppRoute';
import { YoutubeCuepointsPage } from '@app/modules/youtube/screens/cuepoints/YoutubeCuepointsPage';
import { Switch, useRouteMatch } from 'react-router-dom';

/**
 * Admin routes for the YouTube module (cuepoints and future YouTube-specific screens).
 */
export function YoutubeRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <AppRoute path={`${path}/cuepoints/:station`} component={YoutubeCuepointsPage} />
    </Switch>
  );
}
